var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemoSeasonality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 50,
    viewBox: "0 0 80 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recharts544-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    height: 40,
    width: 70
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#bdbdbd",
    strokeWidth: 1.5,
    fill: "none",
    width: 70,
    height: 40,
    d: "M5,24.1L11.363636363636363,23.599999999999998L17.727272727272727,26.25L24.09090909090909,26.399999999999995L30.454545454545453,19.849999999999998L36.81818181818181,20.35L43.18181818181818,14.750000000000002L49.54545454545455,20.9L55.90909090909091,23.650000000000002L62.272727272727266,20.9L68.63636363636363,19.55L75,9.900000000000002"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 24.1,
    r: 2,
    stroke: "#CC0000",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.363636363636363,
    cy: 23.599999999999998,
    r: 2,
    stroke: "#FFA500",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.727272727272727,
    cy: 26.25,
    r: 2,
    stroke: "#CC0000",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.09090909090909,
    cy: 26.399999999999995,
    r: 2,
    stroke: "#CC0000",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.454545454545453,
    cy: 19.849999999999998,
    r: 2,
    stroke: "#00CC00",
    fill: "#00CC00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.81818181818181,
    cy: 20.35,
    r: 2,
    stroke: "#FFA500",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.18181818181818,
    cy: 14.750000000000002,
    r: 2,
    stroke: "#00CC00",
    fill: "#00CC00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.54545454545455,
    cy: 20.9,
    r: 2,
    stroke: "#FFA500",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.90909090909091,
    cy: 23.650000000000002,
    r: 2,
    stroke: "#CC0000",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.272727272727266,
    cy: 20.9,
    r: 2,
    stroke: "#FFA500",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.63636363636363,
    cy: 19.55,
    r: 2,
    stroke: "#00CC00",
    fill: "#00CC00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 9.900000000000002,
    r: 2,
    stroke: "#00CC00",
    fill: "#00CC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoSeasonality);
export default __webpack_public_path__ + "static/media/demo_seasonality.634e2ff33964e11396721bff81cbfe99.svg";
export { ForwardRef as ReactComponent };